import { LitElement, css, html, unsafeCSS, nothing } from 'lit';
import { createRef, ref } from 'lit/directives/ref.js';
import styles from './accordion.scss?inline';

export default class SotbitAccordion extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        open: { type: Boolean, reflect: true, useDefault: true },
        collapseIconLeft: {
            type: Boolean,
            reflect: true,
            attribute: 'collapse-icon-left',
        },
        alignIconRight: {
            type: Boolean,
            reflect: true,
            attribute: 'align-icon-right',
        },
        rotateRight: { type: Boolean, reflect: true, attribute: 'rotate-right' },
        _collapseInProgess: { state: true },
    };

    constructor() {
        super();

        this.open = false;
        this.collapseIconLeft = false;
        this.rotateRight = false;
        this._collapseInProgess = false;
        this._collapseBody = createRef();
    }

    _handleHeaderClick() {
        this._collapseBody?.value?.addEventListener('transitionend', this._handleTransitionEnd, { once: true });
        this.open = !this.open;
        this._collapseInProgess = true;

        this.dispatchEvent(
            new Event('resize', {
                bubbles: true,
                cancelable: false,
                composed: true,
            })
        );
    }

    _handleTransitionEnd = () => {
        this._collapseInProgess = false;
    };

    render() {
        const iconTemplate = html`
            <sotbit-icon
                pointer
                variant="secondary"
                size="m"
                icon="arrow-down"
                rotate="${this.open ? '180' : nothing}"
            ></sotbit-icon>
        `;

        return html`
            <div class="collapse">
                <div class="collapse-header-wrapper">
                    <div
                        part="collapse-header"
                        class="collapse-header ${this.alignIconRight ? 'align-icon-right' : ''}"
                        @click="${this._handleHeaderClick}"
                    >
                        ${this.collapseIconLeft ? iconTemplate : nothing}
                        <slot name="header"></slot>
                        ${!this.collapseIconLeft ? iconTemplate : nothing}
                    </div>
                </div>
                <div class="collapse-body" ${ref(this._collapseBody)}}>
                    <div
                        class="collapse-body-inner ${this.open ? 'open' : ''} ${this._collapseInProgess
                            ? 'transition'
                            : ''}"
                    >
                        <slot></slot>
                    </div>
                </div>
            </div>
        `;
    }
}
